var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CToaster',{attrs:{"autohide":4000}},[_vm._l((_vm.toasts),function(obj){return [_c('CToast',{key:'toast' + obj,attrs:{"color":"success","show":true},on:{"update:show":_vm.onDone}},[_vm._v(" ทำการบันทึกเรียบร้อย ")])]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }